class TuyaDelivery {
  constructor(section) {
    this.section = section;
    this.currentMethod = "courier";
    this.init();
  }

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    this.discountFromUrl = urlParams.get("discount");

    this.cards = this.section.querySelectorAll(".tuya-delivery__method-card");
    this.fields = this.section.querySelectorAll("[data-method-field]");
    this.form = this.section.querySelector(".tuya-delivery__form");
    this.submitBtn = this.section.querySelector(".tuya-delivery__submit-btn");
    this.deliveryGate = this.section.querySelector(".tuya-delivery__gated");

    if (!this.form || !this.submitBtn) return;

    this.billingSection = this.section.querySelector("#BillingSection");
    this.billingFields = this.section.querySelector("#BillingFields");
    this.billingInputs = this.billingFields
      ? this.billingFields.querySelectorAll("input")
      : [];
    this.billingToggle = this.section.querySelector("#SameAsShipping");
    this.billingToggleWrapper = this.section.querySelector(
      "#BillingToggleWrapper",
    );

    this.clientTypeRadios = this.section.querySelectorAll(
      'input[name="client_type"]',
    );
    this.companyFields = this.section.querySelector("#CompanyFields");
    this.companyInputs = this.companyFields
      ? this.companyFields.querySelectorAll("input")
      : [];

    this.cartTotal = parseInt(this.section.dataset.cartTotal || "0", 10);
    this.moneyFormat = this.section.dataset.moneyFormat || "{{amount}} zł";
    this.summaryToggle = this.section.querySelector("[data-summary-toggle]");
    this.summarySidebar = this.section.querySelector("[data-summary-sidebar]");

    this.initEvents();
    this.verifyCart();
  }

  async verifyCart() {
    try {
      const cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok) {
        if (this.deliveryGate) this.deliveryGate.classList.add("is-ready");
        return;
      }

      const cart = await cartResponse.json();
      const hasItems = (cart.items || []).some((item) => item.quantity > 0);

      if (!hasItems) {
        const emptyAlert = this.section.dataset.emptyAlert;
        if (emptyAlert) alert(emptyAlert);
        window.location.href =
          this.section.dataset.cartUrl ||
          (window.Theme &&
            window.Theme.routes &&
            window.Theme.routes.cart_url) ||
          "/cart";
        return;
      }
    } catch (err) {
      console.error(err);
    }

    if (this.deliveryGate) {
      this.deliveryGate.classList.add("is-ready");
    }
  }

  initEvents() {
    this.form.querySelectorAll("[data-normalize]").forEach((input) => {
      input.addEventListener("input", () => {
        if (input.dataset.normalize === "locker") {
          input.value = input.value.toUpperCase();
        }
      });
      input.addEventListener("blur", () => {
        input.setCustomValidity("");
        const value = input.value.trim();
        if (input.dataset.normalize === "locker") {
          input.value = value.replace(/\s+/g, "");
        } else if (input.dataset.normalize === "zip") {
          const digits = value.replace(/\D/g, "");
          input.value =
            digits.length === 5
              ? `${digits.slice(0, 2)}-${digits.slice(2)}`
              : value;
        }
      });
    });

    this.form.querySelectorAll("[data-pattern-error]").forEach((input) => {
      input.addEventListener("input", () => input.setCustomValidity(""));
      input.addEventListener("invalid", () => {
        if (input.validity.patternMismatch) {
          input.setCustomValidity(input.dataset.patternError);
        }
      });
    });

    window.addEventListener("pageshow", () => {
      this.submitBtn.disabled = false;
      this.submitBtn.innerHTML =
        this.submitBtn.dataset.originalText || this.submitBtn.innerHTML;
    });

    if (this.billingToggle) {
      this.billingToggle.addEventListener("change", () =>
        this.updateBillingVisibility(),
      );
    }

    if (this.clientTypeRadios) {
      this.clientTypeRadios.forEach((radio) => {
        radio.addEventListener("change", () =>
          this.updateCompanyFieldsVisibility(),
        );
      });
    }

    this.cards.forEach((card) => {
      card.addEventListener("click", () => {
        this.cards.forEach((c) => c.classList.remove("is-active"));
        card.classList.add("is-active");
        this.currentMethod = card.dataset.method;
        this.toggleMethodFields(this.currentMethod);
        this.updateSummaryPrices();
      });
    });

    if (this.summaryToggle && this.summarySidebar) {
      this.summaryToggle.addEventListener("click", () => {
        const expanded =
          this.summaryToggle.getAttribute("aria-expanded") === "true";
        this.summaryToggle.setAttribute("aria-expanded", !expanded);
        this.summarySidebar.classList.toggle("is-active", !expanded);
      });
    }

    this.toggleMethodFields(this.currentMethod);
    this.updateCompanyFieldsVisibility();
    this.updateSummaryPrices();
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
  }

  updateCompanyFieldsVisibility() {
    const activeRadio = this.section.querySelector(
      'input[name="client_type"]:checked',
    );
    const isCompany = activeRadio && activeRadio.value === "company";

    if (this.companyFields) {
      this.companyFields.style.display = isCompany ? "block" : "none";
    }

    this.companyInputs.forEach((input) => {
      input.required = isCompany;
    });
  }

  updateBillingVisibility() {
    if (!this.billingSection) return;

    if (this.currentMethod === "locker") {
      this.billingSection.style.display = "none";
      this.billingInputs.forEach((input) => (input.required = false));
    } else {
      this.billingSection.style.display = "block";
      if (this.billingToggleWrapper)
        this.billingToggleWrapper.style.display = "block";

      if (this.billingToggle && this.billingToggle.checked) {
        if (this.billingFields) this.billingFields.style.display = "none";
        this.billingInputs.forEach((input) => (input.required = false));
      } else {
        if (this.billingFields) this.billingFields.style.display = "block";
        this.billingInputs.forEach((input) => (input.required = true));
      }
    }
  }

  toggleMethodFields(method) {
    this.fields.forEach((field) => {
      const isActive = field.dataset.methodField === method;
      const inputs = field.querySelectorAll("input");

      field.classList.toggle("is-visible", isActive);

      if (method === "locker" && isActive) {
        const lockerInput = this.section.querySelector("#LockerID");
        if (lockerInput) lockerInput.required = true;

        const extraFields = this.section.querySelector("#LockerExtraFields");
        if (extraFields) {
          extraFields
            .querySelectorAll("input")
            .forEach((input) => (input.required = false));
        }
      } else {
        inputs.forEach((input) => {
          input.required = isActive;
        });
      }
    });
    this.updateBillingVisibility();
  }

  async handleSubmit(e) {
    e.preventDefault();

    const emailInput = this.section.querySelector("#Email");
    const firstNameInput = this.section.querySelector("#FirstName");
    const lastNameInput = this.section.querySelector("#LastName");
    const phoneInput = this.section.querySelector("#Phone");

    const addressInput = this.section.querySelector("#Address");
    const cityInput = this.section.querySelector("#City");
    const zipInput = this.section.querySelector("#Zip");

    const lockerIDInput = this.section.querySelector("#LockerID");
    const lockerAddressInput = this.section.querySelector("#LockerAddress");
    const lockerCityInput = this.section.querySelector("#LockerCity");
    const lockerZipInput = this.section.querySelector("#LockerZip");

    const billingAddressInput = this.section.querySelector("#BillingAddress");
    const billingCityInput = this.section.querySelector("#BillingCity");
    const billingZipInput = this.section.querySelector("#BillingZip");

    const companyNameInput = this.section.querySelector("#CompanyName");
    const companyNIPInput = this.section.querySelector("#CompanyNIP");

    const email = emailInput ? emailInput.value.trim() : "";
    const firstName = firstNameInput ? firstNameInput.value.trim() : "";
    const lastName = lastNameInput ? lastNameInput.value.trim() : "";
    const phone = phoneInput ? phoneInput.value.trim() : "";

    const address = addressInput ? addressInput.value.trim() : "";
    const city = cityInput ? cityInput.value.trim() : "";
    const zip = zipInput ? zipInput.value.trim() : "";

    const lockerID = lockerIDInput
      ? lockerIDInput.value.trim().toUpperCase()
      : "";
    const lockerAddress = lockerAddressInput
      ? lockerAddressInput.value.trim()
      : "";
    const lockerCity = lockerCityInput ? lockerCityInput.value.trim() : "";
    const lockerZip = lockerZipInput ? lockerZipInput.value.trim() : "";

    const billingAddress = billingAddressInput
      ? billingAddressInput.value.trim()
      : "";
    const billingCity = billingCityInput ? billingCityInput.value.trim() : "";
    const billingZip = billingZipInput ? billingZipInput.value.trim() : "";

    const isLocker = this.currentMethod === "locker";
    const useSameAddress =
      !isLocker && this.billingToggle && this.billingToggle.checked;

    const activeRadio = this.section.querySelector(
      'input[name="client_type"]:checked',
    );
    const isCompany = activeRadio && activeRadio.value === "company";
    const companyName =
      isCompany && companyNameInput ? companyNameInput.value.trim() : "";
    const companyNIP =
      isCompany && companyNIPInput ? companyNIPInput.value.trim() : "";

    const visibleFields = Array.from(this.form.elements).filter(
      (el) => el.offsetParent !== null,
    );
    visibleFields.forEach((el) => {
      if (el.type === "text" || el.type === "tel" || el.type === "email") {
        el.value = el.value.trim();
      }
    });
    const invalidField = visibleFields.find((el) => !el.checkValidity());
    if (invalidField) {
      invalidField.reportValidity();
      return;
    }

    this.submitBtn.disabled = true;
    if (!this.submitBtn.dataset.originalText) {
      this.submitBtn.dataset.originalText = this.submitBtn.innerHTML;
    }
    const loadingText = this.submitBtn.dataset.loadingText || "Uzupełnianie...";
    this.submitBtn.innerHTML = `<span>${loadingText}</span>`;

    const resetButton = () => {
      this.submitBtn.disabled = false;
      this.submitBtn.innerHTML = this.submitBtn.dataset.originalText;
    };

    try {
      const finalBillingAddress = useSameAddress ? address : billingAddress;
      const finalBillingZip = useSameAddress ? zip : billingZip;
      const finalBillingCity = useSameAddress ? city : billingCity;

      const attributes = {
        "Metoda dostawy": isLocker ? "Paczkomat InPost" : "Kurier",
        "E-mail": email,
        "Imię": firstName,
        "Nazwisko": lastName,
        "Telefon": phone,
        "Adres dostawy": isLocker ? lockerAddress || lockerID : address,
        "Kod pocztowy": isLocker ? lockerZip || "" : zip,
        "Miejscowość": isLocker ? lockerCity || "" : city,
        "Kod Paczkomatu": isLocker ? lockerID : "",
        "Adres bilingowy": isLocker ? "" : finalBillingAddress,
        "Kod pocztowy bilingowy": isLocker ? "" : finalBillingZip,
        "Miejscowość bilingowa": isLocker ? "" : finalBillingCity,
        "Typ klienta": isCompany ? "Firma" : "Osoba prywatna",
        "Nazwa firmy": companyName,
        "NIP": companyNIP,
      };

      const orderNote = isLocker ? lockerID : "";

      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes, note: orderNote }),
        });
      } catch (err) {
        console.error(err);
      }

      const params = new URLSearchParams();
      params.append("note", orderNote);
      params.append("checkout[email]", email);
      params.append("checkout[shipping_address][first_name]", firstName);
      params.append("checkout[shipping_address][last_name]", lastName);
      params.append("checkout[shipping_address][phone]", phone);
      params.append(
        "checkout[shipping_address][country]",
        this.section.dataset.defaultCountry,
      );
      params.append(
        "checkout[shipping_address][country_code]",
        this.section.dataset.defaultCountryCode,
      );

      if (isCompany) {
        params.append("checkout[shipping_address][company]", companyName);
      }

      const lockerPrefix = this.section.dataset.lockerPrefix;

      if (isLocker) {
        params.append(
          "checkout[shipping_address][address1]",
          lockerAddress || `${lockerPrefix} ${lockerID}`,
        );
        params.append(
          "checkout[shipping_address][address2]",
          lockerAddress ? `${lockerPrefix} ${lockerID}` : "",
        );
        params.append(
          "checkout[shipping_address][city]",
          lockerCity || "Miasto",
        );
        params.append("checkout[shipping_address][zip]", lockerZip || "00-000");
      } else {
        params.append("checkout[shipping_address][address1]", address);
        params.append("checkout[shipping_address][address2]", "");
        params.append("checkout[shipping_address][city]", city);
        params.append("checkout[shipping_address][zip]", zip);
      }

      params.append("checkout[billing_address][first_name]", firstName);
      params.append("checkout[billing_address][last_name]", lastName);
      params.append(
        "checkout[billing_address][address1]",
        isLocker
          ? lockerAddress || `${lockerPrefix} ${lockerID}`
          : finalBillingAddress,
      );
      params.append("checkout[billing_address][address2]", "");
      params.append(
        "checkout[billing_address][city]",
        isLocker ? lockerCity || "Miasto" : finalBillingCity,
      );
      params.append(
        "checkout[billing_address][zip]",
        isLocker ? lockerZip || "00-000" : finalBillingZip,
      );
      params.append("checkout[billing_address][phone]", phone);
      params.append(
        "checkout[billing_address][country]",
        this.section.dataset.defaultCountry,
      );
      params.append(
        "checkout[billing_address][country_code]",
        this.section.dataset.defaultCountryCode,
      );

      if (isCompany) {
        params.append("checkout[billing_address][company]", companyName);
      }

      for (const [key, value] of Object.entries(attributes)) {
        if (value !== undefined && value !== null && value !== "") {
          params.append(`attributes[${key}]`, value);
        }
      }

      const cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok)
        throw new Error(`Cart error: ${cartResponse.status}`);

      const cart = await cartResponse.json();
      const items = (cart.items || [])
        .filter((item) => item.quantity > 0)
        .map((item) => `${item.variant_id}:${item.quantity}`)
        .join(",");

      if (!items) {
        resetButton();
        const emptyAlert = this.section.dataset.emptyAlert;
        if (emptyAlert) alert(emptyAlert);
        window.location.href =
          this.section.dataset.cartUrl ||
          (window.Theme &&
            window.Theme.routes &&
            window.Theme.routes.cart_url) ||
          "/cart";
        return;
      }

      if (this.discountFromUrl) {
        params.append("discount", this.discountFromUrl);
      }

      const rootUrl =
        this.section.dataset.rootUrl === "/"
          ? ""
          : this.section.dataset.rootUrl || "";
      window.location.href = `${rootUrl}/cart/${items}?${params.toString()}`;
    } catch (err) {
      console.error(err);
      resetButton();
      const generalError = this.section.dataset.generalError;
      if (generalError) alert(generalError);
    }
  }

  parsePrice(text) {
    if (!text || !/\d/.test(text)) {
      return 0;
    }
    const cleanText = text.replace(/[^0-9.,]/g, "").replace(",", ".");
    const parsed = parseFloat(cleanText);
    return isNaN(parsed) ? 0 : Math.round(parsed * 100);
  }

  formatMoney(price) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(price, this.moneyFormat);
    }
    const parsedPrice = parseInt(price, 10);
    if (isNaN(parsedPrice)) return price;

    const formattedValue = (parsedPrice / 100).toFixed(2).replace(".", ",");
    return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, formattedValue);
  }

  updateSummaryPrices() {
    const deliveryPriceEl = this.section.querySelector(
      "[data-summary-delivery-price]",
    );
    const totalPriceEl = this.section.querySelector(
      "[data-summary-total-price]",
    );
    const toggleTotalEl = this.section.querySelector(
      "[data-summary-toggle-total]",
    );

    const activeCard = this.section.querySelector(
      ".tuya-delivery__method-card.is-active",
    );
    if (!activeCard) return;

    const priceTextEl = activeCard.querySelector(
      ".tuya-delivery__method-price",
    );
    const priceText = priceTextEl ? priceTextEl.textContent.trim() : "—";

    const deliveryCostCents = this.parsePrice(priceText);

    if (deliveryPriceEl) {
      deliveryPriceEl.textContent = priceText;
      const deliveryRow = deliveryPriceEl.closest(
        ".tuya-delivery__summary-row",
      );
      if (deliveryRow) {
        if (deliveryCostCents === 0) {
          deliveryRow.classList.add("tuya-delivery__summary-row--discount");
        } else {
          deliveryRow.classList.remove("tuya-delivery__summary-row--discount");
        }
      }
    }

    const totalCents = this.cartTotal + deliveryCostCents;
    const formattedTotal = this.formatMoney(totalCents);

    if (totalPriceEl) {
      totalPriceEl.textContent = formattedTotal;
    }
    if (toggleTotalEl) {
      toggleTotalEl.textContent = formattedTotal;
    }

    const vatCents = Math.round((totalCents * 23) / 123);
    const formattedVat = this.formatMoney(vatCents);
    const vatPriceEl = this.section.querySelector("[data-summary-vat-price]");
    if (vatPriceEl) {
      vatPriceEl.textContent = formattedVat;
    }

    const netCents = totalCents - vatCents;
    const formattedNet = this.formatMoney(netCents);
    const netPriceEl = this.section.querySelector("[data-summary-net-price]");
    if (netPriceEl) {
      netPriceEl.textContent = formattedNet;
    }
  }
}

function initTuyaDelivery() {
  const sections = document.querySelectorAll(".tuya-delivery-section-wrapper");
  sections.forEach((sec) => {
    if (sec.dataset.initialized) return;
    sec.dataset.initialized = "true";
    new TuyaDelivery(sec);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTuyaDelivery);
} else {
  initTuyaDelivery();
}

document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector(".tuya-delivery-section-wrapper");
  if (section) {
    if (section.dataset.initialized) delete section.dataset.initialized;
    initTuyaDelivery();
  }
});
